export const zIndexLayers = {
    floating: 100_000,
    modal: 1_000_000,
    dropdown: 10_000_000,
    tooltip: 100_000_000,
    notification: 1_000_000_000,
};
